<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half"><span class="bold">Victoria Crosses on the Western Front Second Battle of Bapaume</span></p>
<p class="half1"><span class="bold">August–September 1918</span></p>
<a id="page_ii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?ca156d60